import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function NutrizioneSuperiorePerIlTuoGatto() {
  return <section data-section-id="223841" id="albano-conta" className="relative w-full bg-background overflow-hidden min-h-screen flex items-center py-12 md:py-20 lg:py-0">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://in-oarfish-1.10web.cloud/wp-content/uploads/2026/05/ba-18.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/borelli_sindaco_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/borelli_sindaco_portrait.png-wvc-sizes" alt="Candidato Sindaco Borelli" loading="lazy" className="w-full h-full object-cover object-center lg:object-[right_center]" />
      </div>

      {}
      <div className="absolute inset-0 bg-black/40 lg:bg-black/30 z-5 pointer-events-none" />

      <div className="absolute top-0 right-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[800px] h-[800px] lg:w-[1200px] lg:h-[1200px] opacity-10 text-secondary">
          <path fill="currentColor" d="M45.7,-76.4C58.9,-69.3,69.1,-55.3,76.5,-40.4C83.9,-25.5,88.5,-9.7,86.2,5.3C83.9,20.3,74.7,34.6,63.7,46.1C52.7,57.6,39.9,66.3,25.6,71.7C11.3,77.1,-4.5,79.2,-19.7,76.3C-34.9,73.4,-49.5,65.5,-61.2,54.1C-72.9,42.7,-81.7,27.8,-85.1,11.8C-88.5,-4.2,-86.5,-21.3,-78.2,-35.5C-69.9,-49.7,-55.3,-61,-40.4,-67.6C-25.5,-74.2,-10.3,-76.1,3.2,-80.6C16.7,-85.1,32.5,-83.5,45.7,-76.4Z" transform="translate(100 100) scale(1.1)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 lg:gap-12 items-center">
          
          <div className="lg:col-span-7 flex flex-col items-start space-y-8 relative z-20 order-2 lg:order-1 lg:pr-12">
            <div className="space-y-6 max-w-2xl">
              <h1 className="font-default text-3xl font-bold leading-[1.1] tracking-tighter animate-in fade-in slide-in-from-bottom-4 duration-700 fill-mode-both sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-primary-foreground">
                Albano Conta
              </h1>
              <div className="w-24 h-1 bg-secondary animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100 fill-mode-both" />
              <p className="font-default text-base sm:text-lg md:text-xl leading-relaxed max-w-xl animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200 fill-mode-both text-secondary">
                Serietà, lavoro, risultati concreti
              </p>
            </div>
            
            <div className="pt-4 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-500 fill-mode-both">
              <Link to="/HowToVotePage">
                <Button size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-lg px-6 h-12 text-base md:px-8 md:h-14 md:text-lg font-semibold transition-all duration-300 ease-out hover:scale-105 hover:shadow-xl hover:shadow-secondary/20">Come si Vota</Button>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 order-1 lg:order-2 hidden lg:block" />

        </div>
      </div>
    </section>;
}